<script lang="ts" setup>
import { EditableComponent } from "@magnolia/vue-editor";
import useDevice from "~/composables/useDevice";
import SliderElement from "~/templates/elements/SliderElement.vue";
import { mapNodes } from "~/utils/helper/magnolia";
import { screens } from "~/tailwind.config.screens";

// todo: correct type needs to be defined
export interface BenefitsComponentAreaProps {
  content?: object; // Magnolia object (renamed from 'main')
}

const props = defineProps<BenefitsComponentAreaProps>();

const { isMobile, isTablet } = useDevice();

const numberOfSlides = computed(() => mapNodes(props.content ?? []).length);

const renderSlider = computed(() => {
  return (
    (isTablet.value && numberOfSlides.value > 2) || (isMobile.value && numberOfSlides.value > 1)
  );
});

const swiperOptions = {
  slidesPerView: 1.3,
  spaceBetween: 8,
  centeredSlides: false,
  loop: false,
  breakpoints: {
    [parseInt(screens.sm)]: {
      slidesPerView: 2.5,
    },
  },
};
</script>

<template>
  <div>
    <div v-if="renderSlider">
      <SliderElement
        :class="'benefits-component-slider'"
        :components="mapNodes(content)"
        :disable-buttons="true"
        :pagination="true"
        :swiper-options="swiperOptions"
      />
    </div>
    <div v-else class="responsive-gap flex">
      <EditableComponent
        v-for="childContent in mapNodes(content)"
        :key="childContent['@id']"
        :content="childContent"
      />
    </div>
  </div>
</template>

<style>
.benefits-component-slider {
  @apply w-full;
}

.benefits-component-slider .swiper-slide {
  @apply h-auto;

  .benefit-tile {
    @apply h-full;
  }
}
</style>
